import React, { useState, useEffect } from 'react';
import Select from 'react-select';




const AsyncPaginateSelect = ({
    defaultModelIds=[],
    modelOptionsRef=null,
    currentModel="",
    modelIdsField=""
}) => {
    const [options, setOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [page, setPage] = useState(-2);
    const [query, setQuery] = useState('');
    const [cache, setCache] = useState({})



    const handleInputChange = (inputValue) => {
        console.log("handleInputChange run")
        setOptions([]);
        setPage(-1);
        setQuery(inputValue);
    };

    const loaddata = () => {
        console.log("loaddata run")
        setIsLoading(true)
    }

    useEffect(() => {
        console.log("query updated", query)
        loaddata()
    }, [query]);

    useEffect(() => {
        if (isLoading) {
            console.log("isLoading updated", isLoading)
            setPage((prev) => prev + 1);
        }
    }, [isLoading]);


    useEffect(() => {

        if (isLoading) {
            console.log("page updated", page)

            if (currentModel in cache && query in cache[currentModel] && page in cache[currentModel][query]["pages"]) {
                setOptions((prev) => [...prev, ...cache[currentModel][query]["pages"][page]]);
                setIsLoading(false);
            }
            else {

                if (currentModel in cache && query in cache[currentModel] && "has_more" in cache[currentModel][query] && !cache[currentModel][query]["has_more"]) {
                    setIsLoading(false);
                    return;
                }

                fetch(`/taxonomy_limits/search_models?page=${page}&query=${query}&model=${currentModel}`)
                    .then((response) => { 
                    console.log("data fetched")
                    return response.json()
                })
                .then((data) => {
                    const newOptions = data.results

                    setOptions((prev) => [...prev, ...newOptions]);
                    
                    setCache((prev) => {
                        
                        var newCache = prev

                        if (!(currentModel in newCache)) {
                            newCache[currentModel] = {}
                        }

                        if (!(query in newCache[currentModel])) {
                            newCache[currentModel][query] = {total_count:data.total_count, pages:{}, has_more: data.has_more}
                        }

                        newCache[currentModel][query]["pages"][page]=newOptions
                        newCache[currentModel][query]["total_count"]=data.total_count
                        newCache[currentModel][query]["has_more"]=data.has_more
                    
                        return newCache
                    })

                    setIsLoading(false);
                })
                .catch((error) => {
                    console.error('Error loading more results:', error);
                    setIsLoading(false);
                });

            }
        }

    }, [page]);

    useEffect(() => {
        console.log("cache updated", cache)
    }, [cache])

    return (
      <Select
        ref={modelOptionsRef}
        options={options}
        onInputChange={handleInputChange}
        isLoading={isLoading}
        isSearchable
        isClearable
        isMulti
        closeMenuOnScroll={false}

        defaultValue={defaultModelIds}

        onMenuOpen={() => {
            console.log("onMenuOpen run")
            loaddata()
        }}
        onMenuScrollToBottom={() => {
            console.log("onMenuScrollToBottom run")
            loaddata()
        }}

        onChange={(val) => {
            var modelIdsFieldInput = document.getElementById(modelIdsField)
            modelIdsFieldInput.value = JSON.stringify(val.map((v => v['value'])))
        }}
      />
    );
};





export default AsyncPaginateSelect;